export const getCreateStep = state => state.data.create.step;
export const getFormData = state => state.data.create.form;
export const getCreateDocumentsRecyclerId = state =>
  state.data.createDocuments?.recyclerId;
export const getCreateDocumentsItems = state =>
  state.data.createDocuments?.documents;
